import { SubTabs } from "./SubTabs";

// An item's two sub-tabs, the same on the quote and the order page (Ben,
// 5 Oct): [Details & quantity] and [Artwork · N needed], so the quantity
// choice and the files are not stacked on one another. Lives in the URL
// (`?view=details|artwork`). A sub-tab holding something the customer must
// do carries the attention dot, the next step of the trail from the tab
// and the item row down to the component itself.

export type ItemPane = "details" | "artwork";

export function ItemSubTabs({
  current,
  artworkNeeded,
  hasArtwork,
  detailsNeedAttention = false,
  onSelect,
}: {
  current: ItemPane;
  /** How many versions need something from the customer. */
  artworkNeeded: number;
  /** False for an item with no artwork (a service, plain envelopes). */
  hasArtwork: boolean;
  /** A quantity still to choose (a quote). */
  detailsNeedAttention?: boolean;
  onSelect: (pane: ItemPane) => void;
}) {
  // An item without artwork shows Details only, with no sub-tab bar.
  if (!hasArtwork) return null;
  const tabs: Array<{ id: ItemPane; label: string; needsYou: boolean }> = [
    {
      id: "details",
      label: "Details & quantity",
      needsYou: detailsNeedAttention,
    },
    {
      id: "artwork",
      label:
        artworkNeeded > 0 ? `Artwork · ${artworkNeeded} needed` : "Artwork",
      needsYou: artworkNeeded > 0,
    },
  ];
  return <SubTabs tabs={tabs} current={current} onSelect={onSelect} />;
}
